var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require('./../../assets/images/logo/ie_logo_menu.png')}}),_c('vs-progress',{attrs:{"percent":_vm.percentage,"color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }